/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { URL_PRINT } from "utils/constants";
import mock from "./mock";
import { AiFillPrinter } from "react-icons/ai";
import { formatNumber } from "utils/formatHelper";
import { InfoPallet } from "services/workOrder_services";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import Close from "@mui/icons-material/Close";
import { CancelConfirmStage } from "services/historyReceive_sevieces";
import * as rootStore from "stores/root_store";
import { async } from "q";
import { toast } from "react-toastify";

interface PalletDetailProps {
  data: InfoPallet | undefined;
}

const column = [
  {
    columnName: "STT",
    align: "text-center whitespace-nowrap",
    visible: true,
  },
  {
    columnName: "Số thẻ treo",
    align: "text-center whitespace-nowrap",
    visible: true,
  },
  {
    columnName: "SL theo thẻ treo",
    align: "text-center whitespace-nowrap",
    visible: true,
  },
  {
    columnName: "SL đã ghi nhận",
    align: "text-center whitespace-nowrap",
    visible: true,
  },
  {
    columnName: "ĐVT",
    align: "text-center whitespace-nowrap",
    visible: true,
  },
  {
    columnName: "Công đoạn hiện tại",
    align: "text-center whitespace-nowrap",
    visible: true,
  },
  {
    columnName: "Hướng dẫn sản xuất",
    align: "text-center whitespace-nowrap",
    visible: true,
  },
  {
    columnName: "Trạng thái thẻ treo",
    align: "text-center whitespace-nowrap",
    visible: true,
  },
  {
    columnName: "Ngày tạo",
    align: "text-center whitespace-nowrap",
    visible: true,
  },
  {
    columnName: "Chức năng",
    align: "text-center whitespace-nowrap",
    visible: true,
  },
];

const columnTable2 = [
  {
    columnName: "Thứ tự công đoạn",
    align: "text-center",
    visible: true,
  },
  {
    columnName: "Công đoạn",
    align: "text-center",
    visible: true,
  },
  {
    columnName: "Người XNHT",
    align: "text-center",
    visible: true,
  },
  {
    columnName: "Thời gian XNHT",
    align: "text-center",
    visible: true,
  },
  {
    columnName: "Người hủy XNHT",
    align: "text-center",
    visible: true,
  },
  {
    columnName: "Thời gian hủy XNHT",
    align: "text-center",
    visible: true,
  },
  {
    columnName: "Hủy XNHT",
    align: "text-center",
    visible: true,
  },
];

const Style = {
  MuiTableCellRoot: {
    fontSize: "13px",
    fontWeight: 700,
    padding: "5px 10px",
    lineHeight: "20px",
    color: "white",
  },
  borderInherit: {
    borderCollapse: "inherit",
  },
  MuiButtonBaseRoot: {
    color: "white !important",
  },
  MuiTableCellRootTd: {
    fontSize: "13px",
    padding: "5px 10px",
    lineHeight: "20px",
    borderBottom: "unset",
  },
  sticky1: {
    position: "sticky",
    left: 0,
    background: "white",
    zIndex: 5,
  },
  sticky2: {
    position: "sticky",
    left: 45.2,
    background: "white",
    zIndex: 5,
  },
  sticky3: {
    position: "sticky",
    left: 294.5,
    background: "white",
    zIndex: 5,
    color: "#0284c7",
  },

  ".MuiOutlinedInput-root": {
    padding: 0,
  },
  ".MuiOutlinedInput-input": {
    fontSize: "13px",
  },
  ".MuiOutlinedInput-notchedOutline": { borderRadius: 0 },
};

const PalletDetail = (props: PalletDetailProps) => {
  const navigate = useNavigate();
  const { data } = props;
  // lưu workOrderId từ roostore
  const { workOrderId } = useParams();
  // State lưu workOderId và orderIndex
  const [dataCancelConfirmStage, setdataCancelConfirmStage] =
    useState<CancelConfirmStage>({
      workOrderId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      orderIndex: 0,
    });
  //#####POPUP
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  //#Xử lý modal
  const [open, setOpen] = useState(false);
  // Xử lý khi đóng modal
  const handleClose = async (e: string) => {
    if (e === "ignore") setOpen(false);
    if (e === "confirm") {
      setOpen(false);
      await rootStore.historyReceivePresenter.cancelConfirmStage(
        rootStore.historyReceiveStore,
        dataCancelConfirmStage
      );
      if (rootStore.historyReceiveStore.cancelConfirmStage.isSuccess) {
        toast.success(rootStore.historyReceiveStore.cancelConfirmStage.message);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    }
  };
  // // Xử lý mở modal
  const handleOpen = (orderIndex: number) => {
    setOpen(true);
    setdataCancelConfirmStage({
      workOrderId: workOrderId ?? "",
      orderIndex: orderIndex,
    });
  };
  //####END POPUP

  return (
    <div>
      <div className="grid grid-cols-2">
        <form className="w-full flex flex-col gap-2">
          <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
            <label className="min-w-[150px] font-medium text-default text-gray-700 sm:text-end ">
              Lệnh sản xuất:
            </label>
            <input
              disabled
              value={data?.workOrderCode && data.workOrderCode}
              className="col-span-2 bg-gray-300 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
            />
          </div>
          <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
            <label className="min-w-[150px] font-medium text-default text-gray-700 sm:text-end ">
              TP/BTP sản xuất:
            </label>
            <input
              disabled
              // value='50-01-018-001001 / 017-0157 /V1.01/2013-10/na'
              value={data?.productName && data.productName}
              className="col-span-2 bg-gray-300 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
            />
          </div>
          <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
            <label className="min-w-[150px] font-medium text-default text-gray-700 sm:text-end ">
              Số lượng sản xuất:
            </label>
            <input
              disabled
              // value={'12,200 Cái'}
              value={
                data?.quantityProduction &&
                `${formatNumber(data.quantityProduction, 0)} Cái`
              }
              className="col-span-2 bg-gray-300 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
            />
          </div>
          <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
            <label className="min-w-[150px] font-medium text-default text-gray-700 sm:text-end ">
              Số thẻ treo đã in:
            </label>
            <input
              disabled
              // value={'5 Thẻ treo'}
              value={
                data?.palletPrinted &&
                `${formatNumber(data.palletPrinted, 0)} Thẻ treo`
              }
              className="col-span-2 bg-gray-300 text-gray-700 border border-gray-300 sm:ml-5 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
            />
          </div>
        </form>
        <div></div>
      </div>
      {/* =========== Table Work Order ===============*/}

      <div className={`overflow-x-auto mt-10`}>
        <TableContainer
          component={Paper}
          className="w-full table-auto overflow-y-hidden space-collapse mb-5 text-default"
        >
          <Table aria-label="simple table" sx={Style.borderInherit}>
            <TableHead className="font-medium text-gray-700 text-default bg-gray-100">
              <TableRow>
                {column?.map((item, index) => {
                  if (item.visible) {
                    return (
                      <TableCell
                        sx={[Style.MuiTableCellRoot]}
                        key={index}
                        scope="col"
                        className={`${
                          item.visible ? "" : "hidden"
                        } py-2 px-2 border text-left bg-primary ${item.align}`}
                        align={`${
                          item.align === "text-center" ? "center" : "inherit"
                        }`}
                      >
                        {item.columnName}
                      </TableCell>
                    );
                  }
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.detailInfoPallets.map((row, index: number): any => (
                <TableRow key={row.id}>
                  {/* Số thứ tự */}
                  <TableCell
                    align="center"
                    sx={[Style.MuiTableCellRootTd]}
                    className="border"
                  >
                    {index + 1}
                  </TableCell>
                  {/* so the treo */}
                  <TableCell
                    align="left"
                    sx={[Style.MuiTableCellRootTd]}
                    className="border whitespace-nowrap"
                  >
                    {row.palletNumber ? row.palletNumber : ""}
                  </TableCell>
                  {/* so luong theo the treo */}
                  <TableCell
                    align="right"
                    sx={[Style.MuiTableCellRootTd]}
                    className="border"
                  >
                    {row.qtyByPallet ? formatNumber(row.qtyByPallet, 0) : ""}
                  </TableCell>
                  {/* so luong da ghi nhan */}
                  <TableCell
                    align="left"
                    sx={[Style.MuiTableCellRootTd]}
                    className="border"
                  >
                    {formatNumber(row.qtyRecordOK, 0)} Đ <br />
                    {formatNumber(row.qtyRecordNotOK, 0)} KĐ
                  </TableCell>
                  {/* DVT */}
                  <TableCell
                    align="left"
                    sx={[Style.MuiTableCellRootTd]}
                    className="border"
                  >
                    {row.unit}
                  </TableCell>
                  {/* Công đoạn hiện tại */}
                  <TableCell
                    align="left"
                    sx={[Style.MuiTableCellRootTd]}
                    className="border"
                  >
                    {row.stepName}
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={[Style.MuiTableCellRootTd]}
                    className="border"
                  >
                    {row.productionGuide}
                  </TableCell>
                  <TableCell
                    align="left"
                    sx={[Style.MuiTableCellRootTd]}
                    className="border"
                  >
                    {row.status}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={[Style.MuiTableCellRootTd]}
                    className="border"
                  >
                    {moment(row.createTime).format("DD/MM/YYYY HH:mm:ss")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={[Style.MuiTableCellRootTd]}
                    className="border"
                  >
                    <div className="flex justify-center">
                      <button className="whitespace-nowrap text-default text-white bg-primary px-2.5 py-0.25 rounded-base border-gray-300 border flex gap-1 items-center justify-center">
                        <a
                          className="flex items-center justify-center gap-2"
                          href={`${URL_PRINT}Reports/ReportWorkOrderCard/Index/${row.id}`}
                        >
                          <AiFillPrinter /> In thẻ treo
                        </a>
                      </button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default PalletDetail;
